module.exports = __webpack_public_path__ + "media/buy-now/bag7-c65ce4a1.png";